import { useAuth0 } from '@auth0/auth0-react';
import { useMemo } from 'react';
import { wrapAccessTokenAccessor } from './access-token';

// Drop-in replacement for `useAuth0().getAccessTokenSilently` that automatically
// redirects to the Auth0 login page when silent renewal fails with
// login_required or interaction_required. See spec:
// docs/superpowers/specs/2026-05-01-auth-login-required-redirect-design.md
export function useAccessToken() {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  return useMemo(
    () => wrapAccessTokenAccessor(getAccessTokenSilently, loginWithRedirect),
    [getAccessTokenSilently, loginWithRedirect]
  );
}
